import { useEffect } from 'react'

interface SeoOptions {
  title: string
  description: string
}

function setMeta(name: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

export function useSeo({ title, description }: SeoOptions) {
  useEffect(() => {
    document.title = title
    setMeta('description', description)
  }, [title, description])
}
